import React from "react";
import Button from "./Button";
import FormGroup from "./FormGroup";
import Input from "./Input";
import PasswordInput from "./PasswordInput";

interface AuthFormField {
  name: "email" | "password" | "confirmPassword";
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  required?: boolean;
}

interface AuthFormProps {
  fields: AuthFormField[];
  onSubmit: (e: React.FormEvent) => void;
  submitLabel: string;
  disabled?: boolean;
  isSubmitting?: boolean;
  className?: string;
}

const AuthForm: React.FC<AuthFormProps> = ({
  fields,
  onSubmit,
  submitLabel,
  disabled = false,
  isSubmitting = false,
  className = "",
}) => {
  const renderField = (field: AuthFormField, index: number) => {
    const isLastField = index === fields.length - 1;
    const groupClassName = isLastField ? "mb-6" : "";

    if (field.name === "email") {
      return (
        <FormGroup key={field.name} className={groupClassName}>
          <Input
            type="email"
            value={field.value}
            onChange={field.onChange}
            placeholder={field.placeholder}
            required={field.required}
            disabled={disabled}
          />
        </FormGroup>
      );
    }

    if (field.name === "password" || field.name === "confirmPassword") {
      return (
        <FormGroup key={field.name} className={groupClassName}>
          <PasswordInput
            value={field.value}
            onChange={field.onChange}
            placeholder={field.placeholder}
            required={field.required}
            disabled={disabled}
          />
        </FormGroup>
      );
    }

    return null;
  };

  return (
    <form onSubmit={onSubmit} className={className}>
      {fields.map((field, index) => renderField(field, index))}
      <Button
        type="submit"
        variant="primary"
        className="w-full disabled:opacity-50"
        disabled={disabled || isSubmitting}
      >
        {isSubmitting ? (
          <span className="inline-flex items-center gap-2">
            <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
            処理中...
          </span>
        ) : (
          submitLabel
        )}
      </Button>
    </form>
  );
};

export default AuthForm;